export const deleted = state => state.deleted
export const error = state => state.error
export const isLoading = state => state.isLoading



// WEBPACK FOOTER //
// ./src/store/modules/label/delete/getters.js